import moment from "moment";
import "moment-timezone";

const getTimezone = () => {
    return moment.tz.guess();
};
const systemAttributes = [
    {
        name: "ID",
        placeholder: "Contact ID",
        value: "id",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Konuşma ID",
        placeholder: "Konuşma ID",
        value: "conversationId",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Kanal ID",
        placeholder: "Kanal ID",
        value: "channelId",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Name",
        placeholder: "Kemal Atatürk",
        value: "name",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Email",
        placeholder: "ataturk@turkey.gov.tr",
        value: "email",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "empty"],
    },
    {
        name: "Message",
        placeholder: "Hello",
        value: "message",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
    },
    {
        name: "Phone",
        placeholder: "05554443322",
        value: "phone",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "starts_with", "ends_with", "empty"],
    },
    {
        name: "Language",
        placeholder: "Turkish",
        value: "language",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "tr",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "empty"],
    },
    {
        name: "Timezone",
        placeholder: "Europe/Istanbul",
        value: "timezone",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: getTimezone(),
    },
    {
        name: "Hour",
        placeholder: "12:00",
        value: "hour",
        type: "system",
        always: true,
        filterMode: true,
        special: false,
        defaultOperator: "less_than",
        defaultFilterValue: "12:00",
        availableOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal", "equal"],
    },
    {
        name: "Weekday",
        placeholder: "1 (Pazartesi)",
        value: "weekday",
        type: "system",
        always: true,
        filterMode: true,
        special: false,
        defaultOperator: "equal",
        defaultFilterValue: "1",
        availableOperators: ["less_than", "less_or_equal", "greater_than", "greater_or_equal", "equal"],
        controlType: "select",
        options: [1, 2, 3, 4, 5, 6, 7].map((x) => {
            return { label: moment().isoWeekday(x).format("dddd"), value: x.toString() };
        }),
    },
    {
        name: "Segments",
        placeholder: "New,Paid",
        value: "segments",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
        availableOperators: ["contain", "not_contain", "empty", "non_empty"],
    },
    {
        name: "Tags",
        placeholder: "#vip,#emergency",
        value: "tags",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
        availableOperators: ["contain", "not_contain", "empty", "non_empty"],
    },
    {
        name: "Gender",
        placeholder: "Male",
        value: "gender",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "male",
    },
    {
        name: "Country",
        placeholder: "Turkey",
        value: "country",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "turkey",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "empty"],
    },
    {
        name: "Referrer",
        placeholder: "https://myshop.com",
        value: "referrer",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
    },
    {
        name: "URL",
        placeholder: "https://myshop.com/login",
        value: "url",
        type: "system",
        filterMode: true,
        always: true,
        defaultOperator: "contain",
        defaultFilterValue: "",
    },
    {
        name: "IP",
        placeholder: "127.0.0.1",
        value: "ip",
        type: "system",
        filterMode: true,
        defaultOperator: "equal",
        defaultFilterValue: "127.0.0.1",
    },
    {
        name: "Last Seen",
        placeholder: moment().format("DD/MM/YYYY"),
        value: "last_seen",
        type: "system",
        filterMode: true,
        defaultOperator: "equal",
        defaultFilterValue: 1,
    },
    {
        name: "User ID",
        placeholder: "123456789",
        value: "user_id",
        type: "system",
        filterMode: true,
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Department",
        placeholder: "Tech Support",
        value: "department",
        type: "system",
        filterMode: true,
        always: true,
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Offline Mode",
        placeholder: "false",
        value: "offline_mode",
        type: "system",
        always: false,
        filterMode: true,
        special: true,
        defaultOperator: "equal",
        defaultFilterValue: "true",
    },
    {
        name: "Available Agents",
        placeholder: "false",
        value: "available_agents",
        type: "system",
        always: false,
        filterMode: true,
        special: true,
        defaultOperator: "equal",
        defaultFilterValue: "true",
    },
    {
        name: "Platform",
        placeholder: "false",
        value: "platform",
        type: "system",
        always: false,
        filterMode: true,
        special: true,
        defaultOperator: "equal",
        defaultFilterValue: "web",
        controlType: "select",
        options: [
            { label: "Web Widget", value: "web" },
            { label: "Test Web Widget", value: "test-web" },
            { label: "Whatsapp", value: "whatsapp" },
            { label: "Instagram", value: "instagram" },
            { label: "Messenger", value: "messenger" },
            { label: "Telegram", value: "telegram" },
            { label: "Linkedin", value: "linkedin" },
            { label: "Twitter", value: "twitter" },
        ],
    },
    {
        name: "Meta Referrals",
        placeholder: "true",
        value: "metaReferrals",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
    },
    {
        name: "Channel",
        placeholder: "Test Channel",
        value: "channelId",
        type: "system",
        always: false,
        filterMode: true,
        special: true,
        defaultOperator: "equal",
        availableOperators: ["equal", "not_equal", "empty", "non_empty"],
    },
    {
        name: "Kullanıcı Son Aksiyon (Saniye)",
        placeholder: "240",
        value: "idleUserTime",
        type: "system",
        defaultOperator: "less_than",
        defaultFilterValue: "",
    },
    {
        name: "YZ Sınıflandırma Sonucu",
        placeholder: "Kargo Durumu",
        value: "ai_class_result",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Meta Comment ID",
        placeholder: "6798960800000000",
        value: "meta_comment_id",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Meta Comment",
        placeholder: "Hi John",
        value: "meta_comment",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Meta Post ID",
        placeholder: "6798960800000000",
        value: "meta_post_id",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Last Meta Post ID",
        placeholder: "6798960800000000",
        value: "last_meta_post_id",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Last Meta Post Caption",
        placeholder: "Mükkemel Bir Manzara",
        value: "last_meta_post_caption",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Last Meta Post Type",
        placeholder: "reels",
        value: "last_meta_post_type",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Rezervation Time",
        placeholder: "12:00",
        value: "reservation_time",
        type: "reservation",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Reservation Day",
        placeholder: "1",
        value: "reservation_day",
        type: "reservation",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Last Trigger Type",
        placeholder: "automation",
        value: "visitor_trigger_type",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Last Trigger Name",
        placeholder: "timer automation 1",
        value: "visitor_trigger_name",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
    },
    {
        name: "Owner",
        placeholder: "Temsilci 1",
        value: "owner",
        type: "system",
        defaultOperator: "equal",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "empty", "non_empty"],
    },
    {
        name: "Son Yüklenen Resim",
        placeholder: "https://example.com/image.jpg",
        value: "lastUploadedImage",
        type: "system",
        defaultOperator: "contain",
        defaultFilterValue: "",
        availableOperators: ["equal", "not_equal", "contain", "not_contain", "empty", "non_empty"],
        description: "Son yüklenen resmin bilgileri (URL, tip, boyut vb.)"
    },
];

export default systemAttributes;
